import { DataBean } from "../DataBean";

export class PayrollDocumentType extends DataBean {


    public async getPayrollDocumentTypeCatalog(id:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getPayrollDocumentTypeCatalog_Number", [id]);
    }
   

    

 
}